/**
 * @file Chart
 * @author zhuping04
 */

import React, {useRef, useEffect} from 'react';
import {findDOMNode} from 'react-dom';

import * as echarts from 'echarts/lib/echarts';
import {BarChart, PieChart, LineChart} from 'echarts/charts';
import {
    LegendComponent,
    LegendScrollComponent,
    GridComponent,
    TooltipComponent,
    TitleComponent
} from 'echarts/components';
import {CanvasRenderer} from 'echarts/renderers';

import {ACUD_PRO_PREFIX} from '../../../_common/constants';
import '../index.less';

const CLS_PREFIX = `${ACUD_PRO_PREFIX}-chart`;

echarts.use([
    BarChart,
    PieChart,
    LineChart,
    LegendComponent,
    LegendScrollComponent,
    GridComponent,
    TooltipComponent,
    TitleComponent,
    CanvasRenderer
]);

export interface ChartProps {
    height?: number | string,
    width?: number | string,
    autoResize?: boolean,
    option?: object
}

const Chart = (props: ChartProps) => {
    const {
        height = 300,
        width = '100%',
        autoResize = false,
        option = {}
    } = props;
    const container = useRef<any>();
    const duChartContainer = useRef<any>();
    const chart = useRef<any>();

    const setAutoResize = () => {
        if (autoResize) {
            const {width, height} = container.current?.parentNode;
            chart.current?.resize({
                width,
                height
            });
        }
    };

    useEffect(() => {
        container.current = findDOMNode(duChartContainer.current);
        chart.current = echarts.init(container.current);
        if (option) {
            chart.current?.setOption(option, {
                notMerge: true
            });
        }

        setAutoResize();
        window.addEventListener('resize', setAutoResize);
        return () => {
            window.removeEventListener('resize', setAutoResize);
        };
    }, []);

    if (option && chart.current) {
        chart.current.setOption(option, {
            notMerge: true
        });
    }

    return (
        <div ref={duChartContainer} style={{width, height}} className={CLS_PREFIX} />
    );
};

export default Chart;